import { createNotistackReducer } from '../../../infra/libs/redux-notistack/createNotistackReducer'
import { RootState } from '../root/RootState'


export const alertsReducer = createNotistackReducer((state: RootState) => state.alerts)
